import { createFileRoute } from '@tanstack/react-router';

import { NetworkPerformancePage } from '../features/reporting/networkPerformance/components/NetworkPerformancePage';

export const Route = createFileRoute('/reporting/network-performance')({
  component: NetworkPerformancePage,
});
